import { render, staticRenderFns } from "./NoticeDialog.vue?vue&type=template&id=f51edcd4&scoped=true"
import script from "./NoticeDialog.vue?vue&type=script&lang=js"
export * from "./NoticeDialog.vue?vue&type=script&lang=js"
import style0 from "./NoticeDialog.vue?vue&type=style&index=0&id=f51edcd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51edcd4",
  null
  
)

export default component.exports